import { ApolloError, GraphQLErrors } from '@apollo/client/errors'
import {
  CustomerInput,
  GuestOccupancyFragment,
  GuestType,
  ReservationDetailFragment,
  ReservedResourceFragment,
  ResourceOccupancyFragment,
  ReservationBillFragment,
  DepositDocumentFragment,
  ProductionAssignedFragment,
  ReservationBillDocumentFragment,
  ReferenceCustomerFragment,
  CreditType,
} from 'src/api/api.generated'
import { Currency } from 'src/api/currency'

export type GuestOccupancyId = {
  reservedResourceId: string
  index: number
}

export type GuestOccupancyF = GuestOccupancyFragment

export type ReservedResourceF = Omit<ReservedResourceFragment, 'guestOccupancies'> & {
  index: number
  currentResourceOccupancy: ResourceOccupancyFragment
  price: number
  guestOccupancies?: GuestOccupancyF[]
}

export type ReservationF = Omit<ReservationDetailFragment, 'reservedResources'> & {
  reservedResources?: Array<ReservedResourceF> | null
  minStart?: Date
  maxEnd?: Date
  webCheckinEnabled: boolean
  checkInDisabled: boolean
  checkOutDisabled: boolean
  customerReferenceList: ReferenceCustomerFragment[]
  credit?: CreditType
}

export type AssignedProductionF = ProductionAssignedFragment & {
  /** Associated to close bill */
  paid?: boolean
}

export type BillF = Omit<ReservationBillFragment, 'productions'> & {
  productions?: AssignedProductionF[] | null
}

export type DepositF = DepositDocumentFragment

export type ReservationBillDocumentF = ReservationBillDocumentFragment

export type ReservationUpdateResult =
  | {
      type: 'SUCCESS'
      reservation: ReservationDetailFragment
    }
  | {
      type: 'FAIL'
      errors?: unknown | GraphQLErrors
    }

export type ReservedResourceUpdateResult =
  | {
      type: 'SUCCESS'
    }
  | {
      type: 'FAIL'
      error?: ApolloError
    }
  | {
      type: 'OVERBOOKING'
      error?: ApolloError
    }

export type UpdateGuestOccupancyParams =
  | {
      type: 'CREATE_CUSTOMER_AND_ASSIGN_GUEST'
      reservation: ReservationF
      reservedResourceId: string
      guestOccupancyIndex: number
      customerInput: CustomerInput
      guestType: GuestType | null
    }
  | {
      type: 'UPDATE_CUSTOMER_AND_ASSIGN_GUEST'
      reservation: ReservationF
      reservedResourceId: string
      guestOccupancyIndex: number
      guestId: string
      customerInput: CustomerInput
      guestType: GuestType | null
    }
  | {
      type: 'ASSIGN_GUEST'
      reservation: ReservationF
      reservedResourceId: string
      guestOccupancyIndex: number
      guestId: string
      guestType: GuestType | null
    }

export type CheckInReservedResourcesInput = {
  reservationId: string
  reservedResources: {
    reservedResourceId: string
    guestIds: string[]
  }[]
}

export enum ReservationHeaderTab {
  RESERVED_RESOURCES = 0,
  RESERVED_RESOURCES_HOURLY = 1,
  BILLS = 2,
  MESSAGES = 3,
  ATTACHES = 4,
}
